import React from 'react';
import {
  Box,
  Typography,
  ButtonGroup,
  Button,
  IconButton,
  Divider,
} from '@mui/material';
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  Delete,
} from '@mui/icons-material';
import { CartItem as ICartItem } from '../../hooks/useCart';
import { useCart } from '../../hooks/useCart';

interface CartItemProps {
  item: ICartItem;
}

export const CartItem: React.FC<CartItemProps> = ({ item }) => {
  const { removeItem, updateItemQuantity } = useCart();

  const handleQuantityChange = (newQuantity: number) => {
    if (newQuantity === 0) {
      removeItem(item.id);
    } else {
      updateItemQuantity(item.id, newQuantity);
    }
  };

  return (
    <Box>
      <Box sx={{ py: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
            {item.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ₹{item.mrp.toFixed(2)} each
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ButtonGroup size="small">
            <Button onClick={() => handleQuantityChange(Math.max(0, item.quantity - 1))}>
              <RemoveIcon fontSize="small" />
            </Button>
            <Button sx={{ px: 2 }}>{item.quantity}</Button>
            <Button onClick={() => handleQuantityChange(item.quantity + 1)}>
              <AddIcon fontSize="small" />
            </Button>
          </ButtonGroup>
          <IconButton
            color="error"
            onClick={() => removeItem(item.id)}
            size="small"
          >
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      </Box>
      <Divider />
    </Box>
  );
};
